// A/B variant B värav: aktiivne AINULT kui utm_content=ad2.
// URL-parameeter võidab (värskeim klikk), muidu localStorage (getUtm salvestab
// utm_content'i sinna juba boot'il — vt index.js UTM boot-capture + stats.js getUtm).
export function isVariantB() {
  try {
    const p = new URLSearchParams(window.location.search).get('utm_content');
    if (p) return p === 'ad2';
    return localStorage.getItem('utm_content') === 'ad2';
  } catch {
    return false;
  }
}
